import { useDispatch } from "react-redux";
import { successAlert } from "./Global/GlobalSlice";

function success(response) {
  console.log(response);

  const dispatch = useDispatch;

  //   const action = () =>
  const v = () => {
    console.log("ran");
    dispatch(
      successAlert({
        message: "response?.data?.statusMessage",
      })
    );
  };

  return v();
}

export default success;
